export enum PositionAssistantMilestoneEnum {
  FirstReply = 'FIRST_REPLY',
  ReviewedCandidateMilestone = 'REVIEWED_CANDIDATE_MILESTONE',
  AddedCandidateMilestone = 'ADDED_CANDIDATE_MILESTONE',
}
